import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { LoginHelpDialogComponent } from '../login-help/login-help-dialog.component';

@Component({
  selector: 'laps-login-landing',
  standalone: true,  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],  template: `
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <!-- Card -->
      <div class="bg-white rounded-lg shadow-md w-full max-w-sm px-8 py-10 flex flex-col items-center gap-6 relative">

        <!-- Help icon — top right corner of card -->
        <button
          mat-icon-button
          class="!absolute top-3 right-3 text-gray-400 hover:text-blue-600"
          aria-label="Login troubleshooting help"
          (click)="openHelp()"
          matTooltip="Having trouble signing in?">
          <mat-icon>help_outline</mat-icon>
        </button>

        <!-- Logo / Title -->
        <div class="flex flex-col items-center gap-2">
          <mat-icon class="text-blue-600 !text-5xl">water</mat-icon>
          <h1 class="text-xl font-semibold text-gray-800 text-center m-0">
            Duke Energy<br />Lake Access Permit System
          </h1>
        </div>

        <p class="text-sm text-gray-500 text-center m-0">
          Sign in to manage your lake access permit applications.
        </p>

        <!-- Sign In Button -->
        <button
          mat-flat-button
          color="primary"
          class="w-full !py-2"
          (click)="signIn()">
          <mat-icon class="mr-1">login</mat-icon>
          Sign In / Create Account
        </button>

        <!-- Help text below button -->
        <p class="text-xs text-gray-400 text-center m-0">
          Having trouble?
          <button
            class="text-blue-600 underline bg-transparent border-0 cursor-pointer p-0 text-xs"
            (click)="openHelp()">
            View troubleshooting tips
          </button>
        </p>

      </div>

      <!-- Footer -->
      <p class="text-xs text-gray-400 mt-6 text-center">
        &copy; {{ currentYear }} Duke Energy. All rights reserved.
      </p>
    </div>
  `,
})
export class LoginLandingComponent {
  readonly currentYear = new Date().getFullYear();  constructor(
    private msalService: MsalService,
    private dialog: MatDialog
  ) {}
  signIn(): void {
    // loginRedirect() with redirectStartPage so MSAL returns to /home after
    // B2C auth — MsalGuard + RoleGuard then route to the correct page.
    // No prompt override: B2C will SSO silently if a valid session exists,
    // or show the login screen if not (same behaviour as before the landing page).
    this.msalService.loginRedirect({
      scopes: [],
      redirectStartPage: '/home',
    });
  }

  openHelp(): void {
    this.dialog.open(LoginHelpDialogComponent, {
      width: '520px',
      maxHeight: '90vh',
      panelClass: 'laps-help-dialog',
    });
  }
}
